<template>
  <v-card-actions>
    <v-layout wrap>
      <v-flex xs4 style="padding-right:5px;">
        <delete-item
          v-if="!isNew && !isClone && onDeleteItem"
          :id="id"
          :onDeleteItem="onDeleteItem"
          :onlyIcon="!drawer"
          :label="deleteLabel"
          block
        />
      </v-flex>
      <v-flex xs4 style="padding: 0 5px;">
        <v-btn
          v-if="drawer"
          @click="onClose"
          block
        >
          {{ $t(cancelLabel ? cancelLabel : 'common.cancel' ,locale) }}
        </v-btn>
        <v-btn
          v-else
          @click="onClose"
          block
        >
          <v-icon>mdi-close-thick</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs4 style="padding-left:5px;">
        <v-btn
          v-if="drawer"
          :color="color ? color : 'primary'"
          @click="onSaveItem"
          block
          :disabled="saving"
        >
        {{ $t(isClone ? 'common.clone' : 'common.save' ,locale) }}
        </v-btn>
        <v-btn
          v-else
          :color="color ? color : 'primary'"
          @click="onSaveItem"
          block
          dark
          :disabled="saving"
        >
        <v-icon>{{ isClone ? 'mdi-content-copy' : 'mdi-content-save' }}</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
</v-card-actions>
</template>
<!--template>
  <v-card-actions>
    <v-spacer />
    <delete-item
      v-if="id"
      :id="id"
      :onDeleteItem="onDeleteItem"
      :onlyIcon="!drawer"
    />
    <v-btn
      v-if="drawer"
      @click="onClose"
    >
      {{ $t('common.cancel' ,locale) }}
    </v-btn>
    <v-btn
      v-else
      @click="onClose"
    >
      <v-icon>mdi-close-thick</v-icon>
    </v-btn>
    <v-btn
      v-if="drawer"
      color="primary"
      @click="onSaveItem"
    >
    {{ $t('common.save' ,locale) }}
    </v-btn>
    <v-btn
      v-else
      color="primary"
      @click="onSaveItem"
    >
      <v-icon>mdi-content-save</v-icon>
    </v-btn>
</v-card-actions>
</template-->
<script>
  import { mapState } from 'vuex'
  import DeleteItem from './DeleteItem'
  export default {
    components: { DeleteItem },
    props: {
      id: {
        type: String,
        required: false,
        default: null
      },
      onDeleteItem: {
        type: Function,
        required: false,
        default: null
      },
      onSaveItem: {
        type: Function,
        required: false,
        default: null
      },
      onClose: {
        type: Function,
        required: false,
        default: null
      },
      deleteLabel: {
        type: String,
        default: null,
      },
      cancelLabel: {
        type: String,
        default: null,
      },
      locale: {
        type: String,
        required: true
      },
      isClone: {
        type: Boolean,
        default: false,
      },
      color: {
        type: String,
        default: null,
      },
    },
    computed: {
      ...mapState('app',['drawer', 'saving']),
      isNew () {
        return !this.id || this.id === 'new'
      }
    },
  }
</script>
